import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, createElementVNode as _createElementVNode, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-field-container"
}
const _hoisted_2 = {
  key: 1,
  class: "RecommendOrderField"
}
const _hoisted_3 = {
  key: 2,
  class: "text-field-container"
}
const _hoisted_4 = ["placeholder"]

import styled from 'vue-styled-components';
import { i18n } from '@/i18n';
import { CustomStyle } from '@/appLogic/interfaces/style';
import { appendImportantStyle } from '@/utils/display/styleUtil';
import { computed } from 'vue';
import { filterStringNumberUndefinedToString } from '@/coreDomainsModule/extends/string';
import AppDatePicker from '@/corePagesModule/components/AppDatePicker.vue';
import NumberInputWithComma from '@/corePagesModule/components/NumberInputWithComma.vue';

/**
 * interface
 */
type InputType = 'recommendValue' | 'recommendCrossDate' | 'recommendNone';
// props

export default /*@__PURE__*/_defineComponent({
  __name: 'RecommendOrderField',
  props: {
    inputType: {},
    textValue: { default: '' },
    inputDate: { default: undefined },
    placeholder: { default: '入力してください' },
    labelDirection: { default: 'row' },
    format: { default: 'yyyy-MM-dd' },
    customStyle: { default: undefined },
    disabledDates: { type: [Function, Array], default: () => [] }
  },
  emits: ["changeText", "changeValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

// emits
const emits = __emit;

//変数
const t = i18n.t;
const locale = computed(() => i18n.locale);

//computed
const date = computed({
  /**
   * 値を取得する
   */
  get: () => props.inputDate,
  /**
   * 値を設定する
   * @param value -値
   */
  set: (value) => {
    // 値に変更があると呼ばれるsetter
    if (!value) {
      return;
    }
    emits('changeValue', value);
  },
});

/**
 *
 * @param value - 値
 */
const checkedValue = (value) => {
  return isNaN(Number(value)) ? undefined : Number(value);
};

const textComputed = computed({
  /**
   * 値を取得する
   */
  get: () => props.textValue,
  /**
   * 値を設定する
   * @param value -値
   */
  set: (value) => {
    // 呼び出し元に反映させる用
    emits('changeText', filterStringNumberUndefinedToString(value));
  },
});

// イベント

//関数

return (_ctx: any,_cache: any) => {
  return (_ctx.inputType === 'recommendValue')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(NumberInputWithComma, {
          id: "example1",
          "model-value": checkedValue(textComputed.value),
          class: "text-input text-field-container__text-input rounded-base-middle",
          placeholder: _unref(t)(_ctx.placeholder),
          "use-placeholder": true,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (textComputed.value = $event))
        }, null, 8, ["model-value", "placeholder"])
      ]))
    : (_ctx.inputType === 'recommendCrossDate')
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(AppDatePicker, {
            modelValue: date.value,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((date).value = $event)),
            class: "text-field-container__text-input",
            "mode-height": 1,
            format: _ctx.format,
            "enable-time-picker": true,
            "month-change-on-scroll": false,
            teleport: true,
            "disabled-dates": _ctx.disabledDates,
            "week-start": "0",
            locale: locale.value,
            placeholder: _unref(t)('日付を選択'),
            "select-text": _unref(t)('選択'),
            "cancel-text": _unref(t)('キャンセル'),
            "show-now-button": true,
            clearable: false,
            "now-button-label": _unref(t)('現在を選択'),
            pad: ""
          }, null, 8, ["modelValue", "format", "disabled-dates", "locale", "placeholder", "select-text", "cancel-text", "now-button-label"])
        ]))
      : (_ctx.inputType === 'recommendNone')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _withDirectives(_createElementVNode("input", {
              id: "example1",
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((textComputed).value = $event)),
              class: "text-input text-field-container__text-input rounded-base-middle",
              placeholder: _ctx.placeholder
            }, null, 8, _hoisted_4), [
              [_vModelText, textComputed.value]
            ])
          ]))
        : _createCommentVNode("", true)
}
}

})